import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import File from "../Layouts/FileForm";
import { showToast } from "src/utils/showToaster";
import { useAddFileMutation } from "src/services/FileManagerService";

type Props = {
  onClose: () => void;
};
type FormValues = {
  files: File[];
};

const AddFileWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const [addFile] = useAddFileMutation();

  const initialValues: FormValues = {
    files: [],
  };

  // Validation Schema
  const validationSchema = object().shape({});

  // Handle Submit
  const handleSubmit = (
    values: FormValues,
    { setSubmitting, resetForm }: FormikHelpers<FormValues>
  ) => {
    const formData = new FormData();
    values.files.forEach((file) => formData.append("files", file));
    addFile(formData).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <File formikProps={formikProps} onClose={onClose} formType="ADD" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddFileWrapper;
